import React, { Component } from 'react';
import { observer } from 'mobx-react';
import {
  Button,
  Modal,
} from 'react-bootstrap';
import { format as phoneFormat } from 'libphonenumber-js';
import { generate } from 'shortid';

import FieldGroup from '../FieldGroup/FieldGroup';
import { UserInfoFormValidation } from '../../tools/Validations';

import './UserInfo.css';

const UserInfoDialog = observer(
class UserInfoDialog extends Component {
  constructor(props) {
    super(props);
    this.ids = {
      name: generate(),
      phone: generate(),
    }
    this.formValidation = new UserInfoFormValidation();
    this.formValidation.test(props.user);
    this.state = { disableSaveButton: false };
  }

  render() {
    const {
      show = false,
      user,
    } = this.props;
    const disableSaveButton = this.state.disableSaveButton || !this.formValidation.passAllValidations();

    return (
      <Modal show={show} onHide={this.onCancel} autoFocus>
        <Modal.Header closeButton>
          <Modal.Title>User info</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={this.onSave}>
            <FieldGroup
              focus
              id={this.ids.name}
              name="name"
              type="text"
              label="Display name"
              value={user.name}
              placeholder="John Smith"
              validation={this.formValidation.name}
              onChange={this.handleChange} />
            <FieldGroup
              id={this.ids.phone}
              name="phone"
              type="text"
              label="Phone number"
              value={phoneFormat(user.phone, "US", "National")}
              placeholder="+1 (604) 123-4567"
              validation={this.formValidation.phone}
              onChange={this.handleChange} />
            <div style={{display: "none"}}>
              <Button type="submit" hidden></Button>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer className="UserInfoDialog-footer">
          <Button onClick={this.onCancel}>Cancel</Button>
          <Button onClick={this.onSave} bsStyle="primary" disabled={disableSaveButton}>Save</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    const { user } = this.props;

    let data = {};
    data[name] = value;
    if (name === "phone") {
      data["phoneVerified"] = false;
    }
    user.set(data);
    this.formValidation.test(user);
  }

  onSave = (e) => {
    e && e.preventDefault && e.preventDefault();
    this.disableSaveButton();
    const { user, onSave } = this.props;
    if (onSave && this.formValidation.passAllValidations()) {
      onSave(user);
    }
    this.disableSaveButton(false);
    return false;
  }

  onCancel = (e) => {
    e && e.preventDefault && e.preventDefault();
    this.formValidation.reset();
    let { onCancel } = this.props;
    if (onCancel) {
      onCancel();
    }

    return false;
  }

  disableSaveButton = (bDisable = true) => {
    this.setState({ disableSaveButton: bDisable });
  }
});

export default UserInfoDialog;


// WEBPACK FOOTER //
// ./src/components/User/UserInfoDialog.js